import KeycloakService from '@src/service/keycloak';
import axios from 'axios';
import toast from 'react-hot-toast';

const axiosInstance = axios.create({

  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30000, // Set timeout (in milliseconds) for requests
  headers: {
    'Content-Type': 'application/json',
    // Other common headers can be added here
  },
});


axiosInstance.interceptors.request.use(

  config => {
    //const uid = useSelector<RootState, string>((state) => state.deviceUId.uid);
    // Modify the request config before sending
    // For example, you can add an authorization header
    //console.log(config.url + "uid="+ uid)

    let uid = window.localStorage.getItem("DEVICE_UUID");
    if (uid) {
      uid = JSON.parse(uid);
      config.url = config.url?.includes("?") ? `${config.url}&uid=${uid}` : `${config.url}?uid=${uid}`
    }
    let auth = JSON.parse(window.localStorage.getItem("authUser")!)
    if (auth) {
      config.headers["Authorization"] = `Bearer ${auth.token}`;
    }

    //config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    return config;
  },
  (error) => {
    // Qualquer status code que está fora da faixa de 2xx faz com que esta função seja acionada
    // Manipule os erros conforme necessário
    if (error.response) {
      // O servidor retornou uma resposta fora do intervalo 2xx
      console.error('Erro na resposta:', error.response);
    } else if (error.request) {
      // A solicitação foi feita, mas nenhuma resposta foi recebida
      console.error('Nenhuma resposta recebida:', error.request);
    } else {
      // Algo aconteceu ao configurar a solicitação que acionou um erro
      console.error('Erro ao configurar a solicitação:', error.message);
    }

    // Opcionalmente, podemos lançar novamente o erro para que ele possa ser tratado localmente também
    return Promise.reject(error);
  }

);

axiosInstance.interceptors.response.use(
  (response) => {
    // Qualquer status code na faixa de 2xx faz com que esta função seja acionada
    // Manipule a resposta conforme necessário
    return response;
  },
  (error) => {
    // Qualquer status code que está fora da faixa de 2xx faz com que esta função seja acionada
    // Manipule os erros conforme necessário
    if (error.response) {
      
      console.error('Erro na resposta:', error.response);
      if(error.response.status === 401){
        //Usuário com sessão expirada ou problemas na sessão, deve des logar
        console.log("Usuário não autenticado des logando.");
        let uri = window.location.origin ;
        console.log("Cleaning user from redux");
        window.localStorage.removeItem("authUser");
        window.localStorage.removeItem("authToken");
        toast.error("Sessão expirada!");
        KeycloakService.CallLogout(uri)
      }
    } else if (error.request) {
      console.error('Nenhuma resposta recebida:', error.request);
    } else {
      console.error('Erro ao configurar a solicitação:', error.message);
    }

    // Opcionalmente, podemos lançar novamente o erro para que ele possa ser tratado localmente também
    return Promise.reject(error);
  }
);

// Interceptors can be added here if needed
// For example, request and response interceptors

export default axiosInstance;